import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Button, Box, Typography } from "@mui/material";
import axios from "axios";
import SuccessModal from "../../utils/SuccessModal";
import ErrorModal from "../../utils/ErrorModal";

const TenderByBuyer = () => {
  const { orgId } = useParams();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const [tenders, setTenders] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [org, setOrg] = useState()
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState();
  const [openError, setOpenError] = useState(false);
  const [errorMsg, setErrorMsg] = useState();

  const handleClose = () => setOpen(false);

  const getTenders = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-org/tenders?orgId=${orgId}&vendorId=${vendorId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setTenders(res.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTenders();
  }, []);

  useEffect(() => {
    const getOrg = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/organization?orgId=${orgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setOrg(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getOrg();
  }, []);

  const columns = [
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      renderCell: (params) => <span style={{fontWeight: 'bold'}}>{params.row.title}</span>
    },
    {
      field: "type",
      headerName: "Tender Type",
      flex: 1,
      renderCell: (params) =>
        params.row.type
          ? params.row.type.charAt(0).toUpperCase() +
            params.row.type.slice(1).toLowerCase()
          : "",
    },
    {
      field: "tenderPublishDate",
      headerName: "Tender Publish Date",
      flex: 1,
    },
    {
      field: "bidSubmissionEndDate",
      headerName: "Bid Close Date",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1.5,
      renderCell: (params) => (
        <>
          <Button
            className="btn-contained"
            sx={{ margin: "0 !important", fontSize: "12px" }}
            onClick={() => handleShortlistTender(params.row.tenderId)}
          >
            Shortlist This Tender
          </Button>
        </>
      ),
    },
  ];

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year} ${time}`;
  };

  const rows =
    tenders &&
    tenders.map((tender) => ({
      ...tender,
      tenderPublishDate: formatDate(tender.tenderPublishDate),
      bidSubmissionStartDate: formatDateTime(tender.bidSubmissionStartDate),
      bidSubmissionEndDate: formatDateTime(tender.bidSubmissionEndDate),
    }));

  const handleShortlistTender = async (tenderId) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender`,
        {
          vendorId: vendorId,
          tenderId: tenderId,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOpen(true)
      setMsg("Tender Shortlisted")
      setIsLoading(true);
      getTenders();
    } catch (error) {
      setOpenError(true)
      setErrorMsg(error.response.data.Exception || "Internal Server Error. Please try again later.")
    }
  };
  return (
    <div>
      <Typography variant="h6" fontWeight={700}>Active Tenders of {org?.orgName}</Typography>
      <div className="dashboard-container">
        <Box sx={{ background: "#fff" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            loading={isLoading}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10]}
            disableRowSelectionOnClick
            disableColumnSelector
            disableDensitySelector
            disableColumnMenu
            disableColumnResize
            slots={{ toolbar: CustomToolbar }}
            getRowId={(row) => row.tenderId}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
            }
            sx={{
              position: "relative",
              border: "none",
              fontFamily: "Inter !important",

              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "700 !important",
              },
              "& .MuiDataGrid-columnHeaders": {
                background: "none !important",
                color: "black",
                fontSize: "14px",
                borderRadius: "10px",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#fff",
              },
              "& .MuiDataGrid-cell": {
                fontSize: "13px",
                border: "none",
              },
              "& .MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                color: "#000 !important",
                border: "1px solid #B0B0B0",
                borderRadius: "12px",
                padding: 1,
              },
              "& .MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
              "& .MuiInputBase-root-MuiInput-root": {
                borderBottom: "none !important",
              },
              [`& .${gridClasses.row}.even`]: {
                backgroundColor: "#EAF4FF",
                // '&:hover': {
                //   backgroundColor: "#f6f6f6",
                // },
              },
              "& .MuiInput-underline:before": {
                borderBottom: "none !important",
              },
              "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
                borderBottom: "none !important",
              },
            }}
          />
        </Box>
      </div>

      <SuccessModal open={open} handleClose={handleClose} msg={msg} />

      <ErrorModal open={openError} handleClose={() => setOpenError(false)} msg={errorMsg} />
    </div>
  );
};

export default TenderByBuyer;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
